import React from "react";

const EmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.343"
      height="12.9"
      viewBox="0 0 20.343 12.9"
    >
      <path
        id="db100"
        d="M183.328,252.87a1.494,1.494,0,0,0-.543.1l8.721,7.4a.755.755,0,0,0,1.023,0l8.706-7.4a1.5,1.5,0,0,0-.543-.1H183.328Zm-1.473,1.271a1.518,1.518,0,0,0-.015.217v9.923a1.5,1.5,0,0,0,.116.589l6.054-5.52Zm20.312,0-6.14,5.2,6.039,5.527a1.5,1.5,0,0,0,.116-.589v-9.923a1.583,1.583,0,0,0-.015-.217Zm-7.279,6.171-1.4,1.186a2.286,2.286,0,0,1-2.946,0l-1.388-1.178-5.97,5.442c.045,0,.093.008.14.008h17.366c.049,0,.1,0,.147-.008l-5.954-5.45Z"
        transform="translate(-181.84 -252.87)"
      />
    </svg>
  );
};

export default EmailIcon;
